module.exports = __webpack_public_path__ + "static/media/serversActive.871d542c.png";